<template>
  <span>
    <v-btn @click="handleShowForm">
      Recalculate invoice
    </v-btn>

    <v-dialog v-model="showModal" max-width="800" persistent>
      <v-card v-if="showModal">
        <v-card-title class="headline">Recalculate invoice additional info</v-card-title>

        <v-card-text>
          <v-form v-model="isValid" ref="form">
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="handleHideForm">Cancel</v-btn>
          <v-btn @click="handleFormSubmit"
                 :disabled="!isSubmitEnabled"
                 :loading="requestInProgress">
            Run
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
  import {mapActions} from "vuex";
  import _ from 'lodash';
  import {notificationService} from "../../../application";
  import ServiceAsBadge from '../../Ui/mcc/ServiceAsBadge'
  import ModalJsonView from "../../Ui/ModalJsonView";

  function getDefaultFormData() {
    return {}
  }

  export default {
    name: 're-calculate-invoice-additional-info-form',
    props: {
      invoiceId: {
        type: Number,
        required: true
      }
    },
    data() {
      return {
        form: getDefaultFormData(),
        showModal: false,
        isValid: false,
        requestInProgress: false,
      }
    },
    watch: {
      showModal() {
        if (!this.showModal) {
          this.resetForm()
        }
      }
    },
    computed: {
      isSubmitEnabled() {
        return this.isValid
      },
    },
    methods: {
      ...mapActions({
        invoiceCalculateInvoiceAdditionalInfo: 'invoiceCalculateInvoiceAdditionalInfo',
      }),
      handleShowForm() {
        this.showModal = true
      },
      handleHideForm() {
        this.showModal = false
      },
      handleFormSubmit() {
        if (!this.isSubmitEnabled) {
          return
        }

        const request = {
          invoiceId: this.invoiceId,
        };

        this.requestInProgress = true;

        this
          .invoiceCalculateInvoiceAdditionalInfo(request)
          .then(() => {
            notificationService.info('Operation success');
            this.resetForm();
            this.requestInProgress = false;
            this.showModal = false
          })
          .catch(e => {
            this.requestInProgress = false;
            notificationService.error('Operation failed');
            throw e
          })
      },
      resetForm() {
        this.form = getDefaultFormData(this.caseInfo)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/analytics/invoices/ReCalculateInvoiceAdditionalInfoForm.vue